// @flow
import documentReady from 'document-ready';
import Mounter from 'shared/utils/mounter';
import CandidatePronunciationRecorder from 'candidate_availability/candidate_pronunciation_recorder';
import CandidatePronounsField from 'candidate_availability/candidate_pronouns_field';

documentReady(() => {
  new Mounter({
    CandidatePronunciationRecorder,
    CandidatePronounsField,
  }).mountAll();
});
